import { render, staticRenderFns } from "./DeliveryDataOutput.vue?vue&type=template&id=88d1572e&scoped=true&"
import script from "./DeliveryDataOutput.vue?vue&type=script&lang=ts&"
export * from "./DeliveryDataOutput.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryDataOutput.vue?vue&type=style&index=0&id=88d1572e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d1572e",
  null
  
)

export default component.exports